import { FC, StrictMode, useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';

import { Toaster } from '@servicetitan/anvil2';
import { HashBrowserRouter } from '@servicetitan/hash-browser-router/dist/hash-browser-router';

import './app.css';
import './design-system.css';
import { provide } from '@servicetitan/react-ioc';
import { App as AppService, AppLoadingState } from '@servicetitan/web-feature-app-service';

import { AppRoutes } from './app-routes';
import { AppSettingsStore } from './common/stores/app-settings.store';
import { JobPickerPage } from './job-picker/components/job-picker-page';

export const App: FC = provide({ singletons: [AppSettingsStore] })(() => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [, setUserClaims] = useState<any>(null);

    useEffect(() => {
        AppService.loading({ state: AppLoadingState.Finished });

        const checkUserStatus = async () => {
            const req = new Request('/bff/user', {
                headers: new Headers({
                    'X-CSRF': '1',
                }),
            });

            try {
                const resp = await fetch(req);
                if (resp.ok) {
                    const claims = await resp.json();
                    setUserClaims(claims);
                    setIsAuthenticated(true);
                } else if (resp.status === 401) {
                    setIsAuthenticated(false);
                }
            } catch {
                setIsAuthenticated(false);
            } finally {
                setIsLoading(false); // Done checking user status
            }
        };

        checkUserStatus();
    }, []);

    const login = () => {
        window.location.href = `/bff/login?returnUrl=${encodeURIComponent('/' + window.location.hash)}`; // Redirect to login endpoint
    };

    return (
        <StrictMode>
            <Toaster id="field-assistant-toaster" />
            <HashBrowserRouter>
                <Switch>
                    <Route path="/job-picker">
                        <JobPickerPage />
                    </Route>
                    {isAuthenticated ? (
                        <AppRoutes />
                    ) : (
                        <Route path="/">
                            {isLoading ? (
                                <div>Loading...</div>
                            ) : (
                                <div>
                                    <p>You are not authenticated</p>
                                    <button data-cy="login-button" onClick={login}>
                                        Login
                                    </button>
                                </div>
                            )}
                        </Route>
                    )}
                </Switch>
            </HashBrowserRouter>
        </StrictMode>
    );
});
